export const defaultColors = ['#7cb5ec', '#90ed7d', '#f7a35c', '#8085e9',
    '#f15c80', '#e4d354', '#2b908f', '#f45b5b', '#91e8e1', '#434348'];
export const darkModeColors = ['#dd6b66', '#759aa0', '#e69d87', '#8dc1a9', 
    '#ea7e53','#eedd78', '#73a373','#73b9bc', '#7289ab', '#91ca8c'];

export const darkModeTextColor = '#EEE';
export const darkTextColor = '#fff';